import { Box, IconButton } from '@mui/material';
import { FC, useState } from 'react';
import { TableRoofSearchTextField, TableRoofSearchTextFieldProps } from './textfield';
import { SearchIcon } from '../../../../../../../../icons';

type Props = {
  onSearch: TableRoofSearchTextFieldProps['onSearch'];
  variant?: 'dark' | 'light';
};

export const TableRoofSearch: FC<Props> = ({ onSearch, variant }) => {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <Box display={'flex'} justifyContent={'flex-end'}>
      {searchOpen && (
        <TableRoofSearchTextField
          onClose={() => setSearchOpen(false)}
          onSearch={onSearch}
          variant={variant}
        />
      )}
      {!searchOpen && (
        <IconButton
          disableRipple
          onClick={() => setSearchOpen(true)}
          sx={{
            '&:hover > svg': {
              color: 'grey.900'
            },
            borderRadius: '8px'
          }}
        >
          <SearchIcon />
        </IconButton>
      )}
    </Box>
  );
};
